import ParentsRequest from '../../utils/parentsRequest';
import { PaymentMethodParams, User } from '../../types';

import getUser from './getUser';
import getPaymentMethods from './getPaymentMethods';
import { SESSION_KEY_USER_DATA } from '../../constants.ts';

const getUserDataOnLogin = async ( 
	userToken: string, 
	updateUserAndSession: ( userData: User ) => void, 
	fetchCart: () => Promise<boolean | undefined>, 
	applyPaymentMethod: ( paymentMethod: PaymentMethodParams ) => void,
) => {
	try {
		const userResponse = await ParentsRequest.get('/users/meta', userToken);
		if (!userResponse.data.success) { 
			return { success: false, message: userResponse.data.message }
		}
	
		if (userResponse.data.data.children.length > 0) {
			userResponse.data.data.children = userResponse.data.data.children.map((child: { dob: string; }) => {
				if (child.dob) {
					const dateParts = child.dob.split('-');
					child.dob = `${dateParts[1]}/${dateParts[2]}/${dateParts[0]}`;
				}
				return child;
			});
		}
	
		localStorage.setItem(SESSION_KEY_USER_DATA, JSON.stringify(userResponse.data.data));
		updateUserAndSession(userResponse.data.data);
	
		await fetchCart();
	
		const paymentMethods = await getPaymentMethods();
		if (paymentMethods && paymentMethods.data) {
			applyPaymentMethod(paymentMethods.data as PaymentMethodParams);
		}
	
		await getUser();
	
		return { success: true };
	} catch (error : any) {
		return { success: false, message: error.response?.data?.message ?? 'Error retrieving user data.' };
	}
};

export default getUserDataOnLogin;